import { render } from "./PokemonPicture.vue?vue&type=template&id=cd189ab4&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=cd189ab4&scoped=true&lang=css"

import exportComponent from "D:\\CarlosRocha\\Vue\\Pokemon Game Wirh Vue\\04-pokemon-game-with-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd189ab4"]])

export default __exports__